import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import config from '../../config';
import { history } from '../../routes';
import { ToastContainer, notify } from '../../libraries/notifications';
import { getObjectWithJsonDataToFormValues, getOwner, formatFullname } from '../../libraries/utils';

import usersActions from '../../context/users/actions';
import bookingsActions from '../../context/bookings/actions';

import Cover from '../../components/commons/Cover';
import Avatar from '../../components/commons/Avatar';
import LayoutSmall from '../../components/layout/LayoutSmall';
import Icon from '../../libraries/icons';
import Loader from '../../components/commons/Loader';

class Professional extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      bookings: null,
      days: ["domingo","lunes","martes","miercoles","jueves","viernes","sabado",],
    }
  }

  componentDidMount() {
    this.getData();
  }

  getProfessional = async () => {
    const params = this.props.match.params;
    if (params.id) {
      await this.props.onGetProfessional({ id: params.id })
      console.log('AFTER GET');
      const error = this.props.professional.error;
      if (error) { 
        notify(this.t(error.message));
      } else {
        const professionalData = getObjectWithJsonDataToFormValues(
          this.props.professional.item,
          ['id', 'first_name', 'last_name', 'cover_image', 'profile_image', 'specialty', 'username', 'description', 'accounts', 'name', 'bio']
        );
        this.setState({ professional: professionalData });
      }
    }
  }
  
  componentWillUnmount() {
    //this.props.onClearCurrent(); 
  }

  getBookings = async () => {
    await this.props.onGetAllBookings({ owner: getOwner(this.state.professional)});
    const { bookings } = this.props;
    if (bookings.error) {
      notify(this.t(bookings.error.message));
    } else {
      this.setState({ bookings: bookings.items });
    }    
  }

  getData = async () => {
    await this.getProfessional();
    await this.getBookings();  
  }

  gotoBack = () => {history.push(config.ROUTES.PROFESSIONALS)}

  render() {
    const { professional, bookings, days } = this.state;
    return (
      <LayoutSmall
        main={{ className: "bg-base-200"}}
        header={{
          title: this.t("Profesional"),
          className: "!bg-transparent fixed z-10 text-primary-content",
          left: { icon: 'arrow_left', action: () => this.gotoBack(null) },
        }}
        container={{ className: "px-0"}}
        loading={this.props.professional.loading}
      >
        <ToastContainer/>
        {this.props.professional.loading && (<Loader containerClassName="mt-10"/>)}
        {!this.props.professional.loading && professional && (
          <>
            <Cover image={null}/>
            <section className="section-card z-20 relative">
              <div className="flex flex-col place-items-center p-4">
                <Avatar
                  image={professional.profile_image}
                  label={professional.username}
                  className="rounded-full w-28 h-28"
                  containerClassName="-mt-1 z-10 border-white border-5 mb-3"
                />
                <h1 className="text-primary">{formatFullname(professional)}</h1>
                <small>{professional.specialty}</small>
              </div>
                <div className="p-4" >
                {this.props.bookings.loading && (<Loader containerClassName="mt-10"/>)}
                {(!bookings || (bookings.length === 0)) && (<>
                    <h4 className="mb-1 mt-2">{this.t("Horario de Atención")}</h4>
                    <p>{this.t("Este profesional no tiene horarios disponibles")}</p>
                  </>)
                }

                {bookings && bookings.map(booking =>
                  <div key={booking.id}>                 
                    <div className="py-4 border-b">
                      <h4 className="mb-1">{this.t("Dirección")}</h4>
                      <small>{booking.json_data.location ? booking.json_data.location.name : "Videollamada"}</small>
                      <h4 className="mb-1 mt-2">{this.t("Horario de Atención")}</h4>
                      {booking.json_data.ranges && booking.json_data.ranges.map((range, index) => {
                        return(
                          <div key={index}>
                            {range.time_ranges && range.time_ranges.length > 0 && (
                              <h4 className="mt-2">{days[range.day_of_week]}</h4>
                            )}
                            {range.time_ranges && range.time_ranges.map((tr, index) => 
                              <small key={index} className="mb-2"> {tr.start_time} hs - {tr.end_time} hs</small>)
                            }
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )}
                {professional.description && <div className="py-4">
                  <h4 className="mb-1">{this.t("Descripción")}</h4>
                  <p className="text-gray-700">{professional.description}</p>
                </div>}
                <label htmlFor="my-modal-2" className="btn btn-success block mt-10 p-3 leading-5" disabled={false && (!bookings || (bookings.length === 0))}>{this.t("PEDIR CONSULTA")}</label> 
              </div>                 
              <div className="flex-col text-center items-center">        
                <input type="checkbox" id="my-modal-2" className="modal-toggle" /> 
                <div className="modal">
                  <div className="modal-box">
                    <div className="flex justify-between items-center border-b pb-3">
                      <h2>{this.t("Tipo de Consulta")}</h2>
                      <label htmlFor="my-modal-2" className="btn btn-ghost p-0">
                        <Icon className="w-8" name="close" />
                      </label>
                    </div>
                    <div className="grid-rows-1">
                      { config.APPOINTMENTS && config.APPOINTMENTS.map((appt, index) => {
                        return (
                          <Link
                            key={index}
                            to={appt.need_booking ? {pathname: config.ROUTES.BOOKING.CALENDAR, state: {appointment_type: appt.type, professional}} : config.ROUTES.CREATE_MESSAGE.replace(':professional_id', professional.id)
                            }>         
                            <div className={"py-4 " + (index + 1 !== config.APPOINTMENTS.length ? "border-b" : "")}>
                              <div className="flex items-center text-left">
                                <Icon className="w-12 text-success" name={appt.icon} />
                                <div className="ml-2">
                                  <h4>{this.t(appt.label)}</h4>
                                  <small className="text-gray-500">{this.t(appt.details)}</small>
                                </div>
                                <Icon className="w-6 text-gray-400 ml-auto" name="cheveron_right" />
                              </div>
                            </div>
                          </Link>                        
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </LayoutSmall>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    professional: state.users.current,
    bookings: state.bookings.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetProfessional: (id) => dispatch(usersActions.get(id)),
    onGetAllBookings: (params) => dispatch(bookingsActions.getAll(params)),
    onClearCurrent: (id) => dispatch(usersActions.clearCurrent()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Professional));
